// components/features/annonces/AnnoncesList.tsx

import { Annonce } from '../../../types/features/Annonce';
import TableList, { SelectAction } from '../../ui/TableList';
import AnnonceRow from './AnnonceRow';

interface AnnoncesListProps {
  annonces: Annonce[];
  onAction: (annonce: Annonce) => void;
  onSelectAnnonces?: (selectedAnnonces: Annonce[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function AnnoncesList({
  annonces,
  onAction,
  onSelectAnnonces,
  selectable = false,
  selectActions
}: AnnoncesListProps) {
  const columns = [
    { header: "Titre", className: "w-2/5" },
    { header: "Type", className: "hidden sm:table-cell w-1/6" },
    { header: "Destinataires", className: "hidden md:table-cell w-1/6" },
    { header: "Statut", className: "hidden lg:table-cell w-1/6" },
    { header: "Publié le", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={annonces}
      columns={columns}
      getId={(annonce) => annonce.id}
      onAction={onAction}
      onSelectItems={onSelectAnnonces}
      selectable={selectable}
      emptyMessage="Aucune annonce trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(annonce, isSelected, onSelect) => (
        <AnnonceRow
          key={annonce.id}
          annonce={annonce}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}